<template lang="pug">
.p-30
  .row.align-items-center.flex-sm-row-reverse.mb-3
    .col-lg-auto.ml-auto.mb-3.mb-lg-0.text-center
      el-button(type="primary", @click="dialog = true") Add Meeting
    .col-md-6.col-lg-4
      el-input(
        v-model="searchInput",
        prefix-icon="el-icon-search",
        placeholder="Search by Name ..."
      )
  .card
    .card-body
      el-table.clickable-rows(
        :data="filteredItems",
        v-loading="loading",
        style="width: 100%"

      )
        el-table-column(label="Title", min-width="180")
          template(slot-scope="props") {{ props.row.title }}
        el-table-column(label="Date", min-width="100")
          template(slot-scope="props") {{  props.row.date }}
        el-table-column(label="Meeting Type", min-width="100")
          template(slot-scope="props" ) {{ props.row.meetingType.meetingType }}
        el-table-column(label="Meeting ID", min-width="260")
          template(slot-scope="props"
            ) <a href="#" @click="copyUrl($event, props.row)">{{ props.row.shortId }}</a>
        el-table-column(label="", align="center", width="100")
          template(slot-scope="props")
            el-dropdown(
              @command="handleRowAction($event, props.row)",
              trigger="click"
            )
              el-button(icon="el-icon-more", circle)
              el-dropdown-menu(slot="dropdown")
                el-dropdown-item(icon="el-icon-link", command="copyLink") Copy Link
                el-dropdown-item(icon="el-icon-edit", command="editMeeting") Edit Meeting
                el-dropdown-item(icon="el-icon-link", command="joinMeeting") Join Meeting
  dialog-add-edit-meeting(
    v-if="dialog",
    :loading="loading",
    :dialog-visible.sync="dialog",
    :edited-item="editedItem",
    :teams="teams",
    :form-title="formTitle",
    @save-item="saveMeeting",
    @delete-item="deleteMeeting",
    @close-dialog="closeDialog"
  )
</template>

<script>
import uuid from 'uuid-v4';
import cleanDeep from 'clean-deep';
import { meeting as initMeeting, team as initTeam } from '@/data/init';
import { meetingTypes } from '@/data/lookups';
import { mapGetters } from 'vuex';
import { meetings as dummyMeetings, types as dummyTypes } from '@/data/static';
import CrudDialogMixin from '@/mixins/crudDialogMixin';
import SubscribeMixin from '@/mixins/subscribeMixin';
import DialogAddEditMeeting from './DialogAddEditMeeting.vue';
import Rooms from '../rooms/Index.vue';

import {
  getMeetingsRecordsByTeamId,
  getMeetingsRecordsByUserId,
  getMeetingRecordsByCompany,
  createMeetingRecord,
  updateMeetingRecord,
  deleteMeetingRecord,
} from '../../models/meetings';

import {
  getTeamRecordsByCompany,
} from '../../models/user';

export default {
  name: 'Meetings',
  components: { DialogAddEditMeeting, Rooms },
  mixins: [CrudDialogMixin, SubscribeMixin],
  data() {
    return {
      searchInput: '',
      teamId: null,
      meetings: dummyMeetings,
      teams: [initTeam],
      types: dummyTypes,
    };
  },
  computed: {
    ...mapGetters('users', ['me', 'isMeSignedIn', 'scopedCompany', 'isSuperAdmin']),
    filteredItems() {
      return this.getFilteredItems();
    },
    companyId() {
      console.log('computed meeting id');
      if (this.scopedCompany) return this.scopedCompany.id;
      return null;
    },
  },
  watch: {
    me(val) {
      if (val) {
        this.init();
      }
    },
  },
  mounted() {
    console.log('mounted meetings');
    if (this.companyId) {
      console.log('mounted meetings', this.companyId);
      this.init();
      this.subscribeToMeetingEvents();
    } else if (this.$route.path !== '/meetings') {
      this.$router.push('/meetings');
    }
  },
  methods: {
    init() {
      if (this.companyId) this.initData();
    },
    initData() {
      this.editedItem = JSON.parse(JSON.stringify(initMeeting));
      this.defaultItem = JSON.parse(JSON.stringify(initMeeting));
      this.getMeetingList();
      this.getTeamListItems();
      this.loading = false;
    },
    meetingPath(row) {
      // Instead of %20 for space we use +
      const title = `${encodeURIComponent(row.title)}`.replaceAll('%20', '+');
      return `/meeting/${title}/${row.shortId}`;
    },
    handleRowAction(command, row) {
      console.log(command, row);
      if (command === 'copyLink') {
        this.copyUrl(this, row);
      }
      if (command === 'editMeeting') return this.editItem(row);
      if (command === 'joinMeeting') {
        return this.$router.push(`${this.meetingPath(row)}`);
      }
      return false;
    },
    copyUrl(evt, row) {
      const copyInput = document.createElement('input');
      const text = `${window.location.origin}/#${this.meetingPath(row)}`;
      document.body.appendChild(copyInput);
      copyInput.value = text;
      copyInput.select();
      document.execCommand('copy');
      document.body.removeChild(copyInput);
      this.$notify({
        message: 'Meeting Link Copied Clipboard',
        type: 'success',
      });
    },

    subscribeToMeetingEvents() {
      this.subscribeAndInvoke(
        [
          'onCreateMeeting',
          'onUpdateMeeting',
          'onDeleteMeeting',
        ],
        this.getMeetingList,
      );
    },

    rowClicked(row) {
      this.editItem(row);
    },
    filterByInput(item) {
      return item.toLowerCase().includes(this.searchInput.toLowerCase());
    },
    filterById(item) {
      if (this.teamId === null) return true;
      return item.includes(this.teamId);
    },
    getFilteredItems() {
      const items = this.items.filter(
        (item) => this.filterByInput(item.title),
      );
      return items;
    },

    getTeamListItems() {
      getTeamRecordsByCompany(this.companyId).then((res) => {
        this.teams.length = 0;
        res.data.getTeamByCompany.items.forEach((team) => {
          this.teams.push(team);
        });
      });
    },

    getMeetingType(id) {
      return meetingTypes.find((obj) => obj.id === id).label;
    },

    getMeetingList() {
      const { userRecord } = this.me;
      console.log(userRecord);
      this.items.length = 0;
      if (userRecord) {
        getMeetingRecordsByCompany(userRecord.companyId).then((res) => {
          res.data.getMeetingByCompany.items.forEach((meeting) => {
            if (!meeting.createdBy && !meeting.teamId) {
              this.items.push(meeting);
            }
          });
          this.items.sort((a, b) => a.title.localeCompare(b.title));
        });
        getMeetingsRecordsByUserId(userRecord.id).then((res) => {
          res.data.getMeetingsByUserId.items.forEach((meeting) => {
            this.items.push(meeting);
          });
          this.items.sort((a, b) => a.title.localeCompare(b.title));
        });
        if (userRecord.team && userRecord.team.items.length > 0) {
          userRecord.team.items.forEach((teamData) => {
            getMeetingsRecordsByTeamId(teamData.teamUserTeamId).then((res) => {
              res.data.getMeetingsByTeamId.items.forEach((meeting) => {
                if (userRecord.id !== meeting.createdBy) {
                  this.items.push(meeting);
                }
              });
              this.items.sort((a, b) => a.title.localeCompare(b.title));
            });
          });
        }
      }
    },
    async saveMeeting() {
      this.loading = true;
      const { userRecord } = this.me;
      console.log('userRecord', userRecord);
      this.editedItem.createdBy = userRecord.id;
      console.log('while creating the meeting ', this.editedItem);
      if (this.editedItem.id) {
        ['createdAt', 'updatedAt', 'companyId', 'date'].forEach((attr) => {
          delete this.editedItem[attr];
        });
        this.updateMeeting();
      } else {
        this.editedItem.id = uuid();
        this.editedItem.companyId = this.companyId;

        const baseId = String(new Date().getTime());
        // eslint-disable-next-line
        this.editedItem.shortId = `${baseId.slice(0, 4)}-${baseId.slice(4, 8)}-${baseId.slice(8, 12)}`;
        console.log(baseId, this.editedItem.shortId);
        if (this.editedItem.date === '') {
          this.editedItem.date = 'OPEN';
        }
        console.log(this.editedItem);
        this.createMeeting();
      }
    },

    createMeeting() {
      createMeetingRecord(this.editedItem).then((res) => {
        console.log(res);
      }).catch((err) => {
        console.log(err);
      }).finally(() => {
        this.closeDialog();
        this.loading = false;
      });
    },

    updateMeeting() {
      updateMeetingRecord(this.editedItem).then((res) => {
        console.log(res);
      }).catch((err) => {
        console.log(err);
      }).finally(() => {
        this.closeDialog();
        this.loading = false;
      });
    },

    deleteMeeting() {
      const meetingItem = cleanDeep(this.editedItem);
      const { id } = meetingItem;
      const that = this;
      this.$msgbox({
        title: 'Message',
        type: 'warning',
        message: 'This will permanently delete the record. Continue?',
        showCancelButton: true,
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = 'Deleting...';
            that.deleteMeetingItem(id).then(() => {
              instance.confirmButtonLoading = false;
            }).catch(() => {
              this.notifyMsg('error in deleting company');
            });
            instance.confirmButtonLoading = false;
            this.closeDialog();
            done();
          } else {
            done();
          }
        },
      }).then(() => {
        this.$message({
          type: 'success',
          message: 'Delete completed',
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete cancelled',
        });
      });
    },
    deleteMeetingItem(id) {
      return new Promise((resolve, reject) => {
        if (id && id !== '0') {
          // Meeting delete company user record to
          deleteMeetingRecord({ id }).then(() => {
            resolve();
          }).catch((e) => {
            console.log(e);
            reject(new Error(e));
          });
        } else {
          resolve();
        }
      });
    },
  },
};
</script>
